import { Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigDataService } from '../../../services/config-data.service';
import { DatosContrato } from '../../../models/datos-contrato';
import { IboxtoolsItem } from '../../../models/iboxtools-item';
import { ContratoService } from '../../../services/datos-contratos.service';
import { ClaseContratoService } from '../../../services/claseContrato.service';
import { DatosOrganizativosService } from '../../../services/datosOrganizativos.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacionComponent } from '../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MessageService} from 'primeng/api';
import { ErroresService } from '../../../core/services/errores.service';
import {MyValidations} from '../../../utils/my-validations';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { PersonalCurrentFilter } from '../../../models/personalCurrentFIlter';
import { MomentSetService } from '../../../core/services/moment-set.service';

@Component({
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  providers: [MessageService],
  styleUrls: ['./contratos.component.css']
})
export class ContratosComponent implements OnInit {
  
  //Datos de entrada
  @Input() legajo;
  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  
  contrato: any;
  form: FormGroup;
  clasesContratosList: any;
  contratosList: any;
  clasesContratosTodos: any;
  datosO:any;
  cortarRegistro: boolean = false;
  public cargaCompleta = false;

  constructor(private configDataSrv: ConfigDataService,
    private claseContratoService: ClaseContratoService,
    private datosOrganizativosSrv: DatosOrganizativosService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private contratoSrv: ContratoService,
    private fb: FormBuilder,
    private erroresService: ErroresService,
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { 
    }


  MensajeError: string;
  disabledEditing: boolean = true;
  eliminando: boolean;
  eliminacionInvalida: boolean;
  contratosInvalida: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  submitted = false;
  ingreso: any;

  contratosHistoryList: any;
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  
  get registerFormControl() { return this.form?.controls; }

  ngOnInit(): void
  {
    this.contrato = null;
    
    let filter: PersonalCurrentFilter={
      id: this.personalId,
      fecha: new Date().toDateString()
    };
    //Datos Organizativos vigente
    this.datosOrganizativosSrv.getByPersonalCurrent(filter).subscribe(data => {this.datosO = data.data});

    this.configDataSrv.getComboContratos()
      .subscribe(
        data => {
          this.clasesContratosList=data;
          this.clasesContratosTodos=data;
        },
        error => {
          console.log(error);
        });
    
    this.configurarValidadores();
    this.obtenerActual();
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Contratos")) this.permisoEdicion = true;
  }

  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      personal: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      claseContrato: ['', Validators.required],
      fechafinC: ['', [Validators.required, MyValidations.fecCompHasta]],
      fechaFinPrueba: ['', [Validators.required, MyValidations.fecCompHasta]],
      periodoPrueba: ['', Validators.required],
      horasMensuales: ['', Validators.required],
      horasJornadaLaboral: ['', Validators.required],
      desc: [''],
    });
  }

  cargarClasecontratos(desde,hasta)
  {
    let paisPersonal = null;
    this.clasesContratosList = null;
    paisPersonal = this.datosO.sociedadNavigation.pais;
    
    this.claseContratoService.getByPais(paisPersonal).subscribe(data =>
    {
      this.clasesContratosList = data;
    });
  }

  onChangeFechas() {
    let desde = this.form.get("desde").value;
    let hasta = this.form.get("hasta").value;
    this.cargarClasecontratos(desde,hasta);    
  }
  
  setearForm(contrato: DatosContrato)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(contrato?.id);
      this.form.controls['personal'].setValue(contrato?.personal);
      this.form.controls['desde'].setValue(new Date(contrato?.desde));
      this.form.controls['hasta'].setValue(new Date(contrato?.hasta));
      this.form.controls['claseContrato'].setValue(contrato?.claseContrato);
      this.form.controls['fechafinC'].setValue(new Date(contrato?.fechafinC));
      this.form.controls['fechaFinPrueba'].setValue(new Date(contrato?.fechaFinPrueba));
      this.form.controls['periodoPrueba'].setValue(contrato?.periodoPrueba);
      this.form.controls['horasMensuales'].setValue(contrato?.horasMensuales);
      this.form.controls['horasJornadaLaboral'].setValue(contrato?.horasJornadaLaboral);

      if (contrato != null && contrato.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }
    }
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.contrato))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.contratoSrv.delete(this.contrato.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              this.obtenerActual();
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.contrato))
    {
      this.habilitarEdicion();
      var $this = this;
      this.cargarClasecontratos(this.form.get("desde").value,this.form.get("hasta").value);
      setTimeout(function ()
      {
        $this.form.controls['desde'].disable();
        $this.form.controls['hasta'].disable();
      });
    }
    
  }

  OnPeriodChange(index: number)
  {
    this.clasesContratosList = this.clasesContratosTodos;
    let contrato = this.contratosList.find(d => d.id == index);
    this.contrato = contrato;
    this.setearForm(this.contrato);
    // this.cargarClasecontratos(this.contrato.desde,this.contrato.hasta)
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    if (this.contratosList != undefined)
    {
      if (this.contrato.id == 0 && this.contratosList.length == 0)
      {
        this.contrato = null;
      }
      else if (this.contrato.id == 0 && this.contratosList.length > 0)
      {
        this.contrato = this.contratosList[0];
      }
    }
    else
    {
      this.contrato = null;
    }

    this.setearForm(this.contrato);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    this.submitted = true;
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.form.getRawValue();

      let datosCon: DatosContrato = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseContrato: formulario.claseContrato,
        fechafinC: this.momentService.saveDateServer(formulario.fechafinC, false),
        fechaFinPrueba: this.momentService.saveDateServer(formulario.fechaFinPrueba, false),
        periodoPrueba: formulario.periodoPrueba,
        horasMensuales: formulario.horasMensuales,
        horasJornadaLaboral: formulario.horasJornadaLaboral,
        desc: formulario.desc
      };

      this.contratoSrv.save(datosCon, this.cortarRegistro).subscribe(
        contrato =>
        {
          contrato.desde = this.momentService.convertDateServer(contrato.desde);
          contrato.hasta = this.momentService.convertDateServer(contrato.hasta);
          contrato.fechafinC = this.momentService.convertDateServer(contrato.fechafinC);
          contrato.fechaFinPrueba = this.momentService.convertDateServer(contrato.fechaFinPrueba);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Contrato guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial();
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //contrato.desde = contrato.desde.replace('Z', '');
          this.setearForm(contrato);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.contratosInvalida = true;
            
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      let fdesde = new Date().toString();
      
      if (this.fechaslist != undefined){
        let fecha = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
        fdesde = fecha.desde
      }
      let contrato: DatosContrato = { id: 0, personal: this.personalId, desde: fdesde, hasta: new Date("2999-12-31T23:59:59").toString(), claseContrato: 0, desc: "", fechafinC: new Date().toString(), fechaFinPrueba: new Date().toString(), horasJornadaLaboral: "", horasMensuales: "", periodoPrueba: "" };
      this.contrato = contrato;
      this.setearForm(contrato);
    
      let fhasta = new Date("2999-12-31T23:59:59");
      this.cargarClasecontratos(fdesde,fhasta);

      this.habilitarEdicion();
      this.form.controls['id'].setValue(0);
      this.form.controls['hasta'].setValue(fhasta);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.form.controls['hasta'].disable();
      });
    }
  }

  add()
  {
    this.OnNewChange(true);
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarForm(false);
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarForm(true);
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.contratosHistoryList = [];
    this.contratosList = [];
    this.habilitarForm(false);
  }

  private obtenerHistorial()
  {
    this.contratoSrv.getHistoryByPersonalId(this.personalId).subscribe(
      contratos =>
      {
        contratos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechafinC = this.momentService.convertDateServer(currentValue.fechafinC);
          currentValue.fechaFinPrueba = this.momentService.convertDateServer(currentValue.fechaFinPrueba);
        });

        this.contratosHistoryList = [];

        if (contratos.length > 0)
        {
          contratos.forEach(d =>
          {
            let item = new IboxtoolsItem(d);
            this.contratosHistoryList.push(item);
          });

          this.contratosList = contratos;
        }
        else
        {
          this.setearForm(null);
          this.contrato = null;
          this.contratosList = [];
        }
      },
      error =>
      {
        console.log(error);
      });
  }

  private obtenerActual()
  {
    let fechaHoy = new Date();
    this.contratoSrv.getByPersonalId(this.personalId).subscribe(
      contratos =>
      {
        contratos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.fechafinC = this.momentService.convertDateServer(currentValue.fechafinC);
          currentValue.fechaFinPrueba = this.momentService.convertDateServer(currentValue.fechaFinPrueba);
        });

        if (contratos.length > 0)
        {
          this.contrato = contratos.find(f=> Date.parse(f.desde) <= fechaHoy.getTime() &&
                                             Date.parse(f.hasta) >= fechaHoy.getTime());
          
          if (this.contrato == null) this.contrato = contratos[0];
          this.obtenerHistorial();
        }
        else
        {
          this.contrato = null;
        }
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.form.get("desde").value.toDateString();
    let hasta = this.form.get("hasta").value.toDateString();
    
    let fingreso = new Date(this.ingreso.desde).toDateString();
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      //Valida que la fecha desde no sea anterior a la fecha de ingreso
      this.form.get("desde").setErrors({'desdeAnterior': true });
    }else{
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
      
    }

    if (this.form.valid)
    {
      return true;
    }
    else
    {
      this.contrato.form.markAllAsTouched();
      return false;
    }
  }

  
  onChangeContrato(event) {
    console.log('event :' + event);
    console.log(event.value);
    let contrato = event.value
    if (contrato != null) {
      let claseContrato = this.clasesContratosList.find(d => d.id == contrato);
      //traer datos del contrato
      if (claseContrato != undefined) {
        this.form.controls['periodoPrueba'].setValue(claseContrato?.periodoPrueba);
      }
    }
  }
  
  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }

  
}

